import { Box, Flex } from "@chakra-ui/react";
import { FC } from "react";
import { ChannelInfoSection } from "../../molecules/ChannelInfoSection";
import ChannelLeadersList from "../../molecules/ChannelLeadersList";
import ChannelLeadersListSkeleton from "../../molecules/ChannelLeadersList/ChannelLeadersListSkeleton";
import { Channel, User } from "@/schemaTypes";

interface ChannelDetailsMainProps {
  channel: Channel;
  isFollowing: boolean;
  leaders: User[];
  onToggleFollow?: (channelId: string) => void;
  isFollowLoading?: boolean;
  isUserLoggedIn: boolean;
  onLoginRequired?: (channelId: string) => void;
  leadersLoading?: boolean;
}

export const ChannelDetailsMain: FC<ChannelDetailsMainProps> = ({
  channel,
  isFollowing,
  leaders,
  onToggleFollow,
  isFollowLoading,
  isUserLoggedIn,
  onLoginRequired,
  leadersLoading,
}) => {
  return (
    <Flex
      mt={{ base: 4, md: "32px" }}
      flexDir={{ base: "column", md: "row" }}
      justify="space-between"
      gap="24px"
    >
      <Box>
        <ChannelInfoSection
          channel={channel}
          isFollowing={isFollowing}
          onToggleFollow={onToggleFollow}
          isFollowLoading={isFollowLoading}
          isUserLoggedIn={isUserLoggedIn}
          onLoginRequired={onLoginRequired}
        />
      </Box>
      <Box mt={{ base: 4, md: 0 }} w={{ base: "100%", md: "fit-content" }}>
        {leadersLoading ? (
          <ChannelLeadersListSkeleton />
        ) : (
          <ChannelLeadersList leaders={leaders} />
        )}
      </Box>
    </Flex>
  );
};
